import {
  getAppid,
  getOpenid,
  IsvConfig
} from '@/api/user.js'
import {
  setToken,
  setOpenid,
  setTenantId,
  setTenantName,
  setTenantLogo,
  setStartTime,
  getTenantId,
  setEndTime,
  setTime
} from '@/libs/auth.js'

import store from '@/store'

export function getIsvConfig(callback) {
  IsvConfig({ domain: window.location.host }).then(res => {
    setTenantId(res.data.tenant_num || '')
    setTenantName(res.data.short_name || '')
    setTenantLogo(res.data.logo || 'https://mat.uphicoo.com/agent/20190704/3bac6da2-6aa0-33be-bbd4-ee910866595c.png')
    store.state.tenant_id = res.data.tenant_num || ''
    callback()
  }).catch()
}

export function already_wx_auth(commit) {
  const url = location.search // 获取url中"?" 符后的字串
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    var str = url.substr(1)
    const strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  if (theRequest.start) {
    setStartTime(theRequest.start)
    setTime(theRequest.start + '至' + theRequest.end)
  }
  if (theRequest.end) {
    setEndTime(theRequest.end)
  }
  commit()
}

export function wx_auth(commit) {
  getIsvConfig(() => {
    getAppid({ tenant_num: getTenantId() }).then(res => {
      const appid = res.data.appid
      const _scope = 'snsapi_base'
      getUrl(appid, _scope, commit)
    }).catch(err => {
      // eslint-disable-next-line
      $.alert(err.message, () => {
        // eslint-disable-next-line
        WeixinJSBridge.call('closeWindow')
      })
    })
  })
}

let code = ''

export function getUrl(appid, _scope, commit) {
  const AUTH_URL = process.env.VUE_APP_AUTH_URL
  const url = location.search // 获取url中"?" 符后的字串
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    var str = url.substr(1)
    const strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  code = theRequest.code

  if (theRequest.start) setStartTime(theRequest.start)
  if (theRequest.end) setEndTime(theRequest.end)
  if (theRequest.start) setTime(theRequest.start + '至' + theRequest.end)

  if (!code) {
    // debugger
    window.location =
         AUTH_URL + '/weixin/' +
        _scope +
        '?appid=' +
        appid +
        '&redirect_url=' +
        encodeURIComponent(window.location.href)
    commit()
  } else {
    getOpenid(code).then(res => {
      if (res.code === '000000') {
        if (!res.data.token) {
          setToken('')
          setOpenid('')
          window.location = '/login'
        } else {
          setToken(res.data.token)
          setOpenid(res.data.openid)
          store.state.token = res.data.token
          store.state.openid = res.data.openid
          window.location = '/member'
        }
      }
    }).catch(res => {
      if (res.code === '100000') {
        setOpenid(res.data.openid)
        store.state.openid = res.data.openid
        window.location = '/login'
      }
      if (res.code === '110000') {
        setOpenid(res.data.openid)
        store.state.openid = res.data.openid
        window.location = '/login'
      }
    })
  }
}
